import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import { DefaultRepImageURL } from '../../containers/DefaultStyles/Shared';
import InputGroup from '../InputGroup';
import InputGroupCustom from '../InputGroupCustom';
import TextareaGroup from '../TextareaGroup';
import DropDownSelect from '../DropDownSelect';

import { validateStep1 } from './validations';
import { requiredFormElements } from './representatives';

import Button from '../../components/Button';
import TwoGroup from '../../components/TwoGroup';
import {
    relevantRepresentatives,
    joinEnglish
} from '../../utils/localRepresentative/parser';
import { copyFor, capitalization } from '../../copy/copy';
import { findCachedValueByActionIdentifier } from '../../utils/formCaching/helpers';
import { cacheFormData } from '../../utils/formCaching/actions';
import { isPortrait } from '../../utils/size';

const namePlaceholder = () => copyFor('placeholders', 'yourName', 'email');

const DetailsFormContainer = styled.form`
    flex: 1;
    padding: 0;
    display: flex;
    flex-direction: column;
`;

const Row = styled.div`
    margin: 0 -0.5em;
    transition: opacity 0.6s;

    @media (max-width: 30em) {
        ${props => (props.senatorsNotAvailable ? 'margin-top: -12px;' : '')};
    }

    .label-response {
        label {
            top: 6px;
        }
        @media (min-width: 30em) {
            label {
                top: -14px;
            }
            position: absolute;
            width: 100%;
            transition: bottom 0.6s;
            bottom: 142px;
            ${props => (props.senatorsNotAvailable ? 'bottom: 202px !important;' : '')};
        }
    }

    textarea {
        ${props => (props.senatorsNotAvailable ? 'height: 130px !important;' : '')};
        @media (max-width: 30em) {
            ${props => (props.senatorsNotAvailable ? 'height: 300px !important;' : '')};
        }
    }

    &.row-wrapper-3 {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        @media (max-width: 30em) {
            position: static;
            width: auto;

            textarea {
                height: 175px;
            }
        }
        .message-response {
            ${() => !isPortrait() && `bottom: 80px !important;`};
            width: ${() => (isPortrait() ? `100%` : `103%`)};
        }
    }

    &.focused {
        ${() => !isPortrait() && `opacity: 0;`};

        &.row-wrapper-3 {
            opacity: 1;

            .label-response {
                bottom: 282px !important;
            }

            textarea {
                height: 210px !important;
            }
        }
    }
`;

const FullRow = styled.div`
    width: 100%;
    padding: 0 8px;
    position: relative;
`;

const ButtonGroup = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    position: absolute;
    right: 0;
    bottom: 10px;
    width: 70%;

    @media (max-width: 30em) {
        width: 100%;
    }

    > div {
        position: relative;
    }

    button {
        &.submitButton {
            margin-left: 0.5em;

            @media (max-width: 30em) {
                width: calc(50% - 0.5em);
            }
        }

        &.middleButton {
            @media (max-width: 30em) {
                width: calc(50% - 0.5em);
                margin-right: 0.5em;
            }
        }

        &:focus {
            outline: none;
        }
    }
`;

const getActiveTopic = (options, issue, subIssue) => {
    const issueTopics = issue && issue.senatorTopics ? issue.senatorTopics : [];
    const subIssueTopics =
        subIssue && subIssue.senatorTopics ? subIssue.senatorTopics : [];
    const matchedSubIssueTopics = subIssueTopics.filter(si => options.indexOf(si) > -1);
    if (matchedSubIssueTopics.length > 0) return matchedSubIssueTopics[0];
    const matchedIssueTopics = issueTopics.filter(si => options.indexOf(si) > -1);
    if (matchedIssueTopics.length > 0) return matchedIssueTopics[0];
    return options.find(o => o === 'Other') || null;
};

class DetailsFormMultiRepStep1 extends React.Component {
    constructor() {
        super();
        this.state = {
            textAreaFocused: false
        };
    }

    toggleTextAreaFocused = () => {
        if (!isPortrait()) {
            setTimeout(
                () => {
                    this.setState({ textAreaFocused: !this.state.textAreaFocused });
                },
                !this.state.textAreaFocused ? 0 : 300
            );
        }
    };

    render() {
        return (
            <DetailsFormContainer autocomplete="on">
                <Row className="row-wrapper-1">
                    <FullRow>
                        <Field
                            name="recipient"
                            component={InputGroupCustom}
                            onDeleteClick={this.props.onDeleteClick}
                            onAddClick={this.props.onAddClick}
                            onShowRepresentatives={this.props.onShowRepresentatives}
                            type="text"
                            label="To"
                            placeholder="Add Receipients"
                            representatives={this.props.representatives}
                            hiddenRepresentatives={this.props.hiddenRepresentatives}
                            representativesVisibility={
                                this.props.representativesVisibility
                            }
                        />
                    </FullRow>
                </Row>
                <Row className="row-wrapper-2">
                    {this.props.requiredFormElements
                        .filter(function(a) {
                            return a.name === 'Topic';
                        })
                        .map(a => (
                            <FullRow key={a.index}>
                                <Field
                                    name="topic"
                                    component={
                                        a.options.length > 0 ? DropDownSelect : InputGroup
                                    }
                                    options={a.options}
                                    defaultOption={
                                        this.props.initialValues.topic || a.defaultOption
                                    }
                                    label="Subject"
                                    type="text"
                                />
                            </FullRow>
                        ))}
                </Row>
                <Row
                    className="row-wrapper-3"
                    senatorsNotAvailable={this.props.senatorsNotAvailable}
                >
                    <FullRow>
                        <Field
                            title="message"
                            name="message"
                            component={TextareaGroup}
                            label="Message Text"
                            toggleTextAreaFocused={this.toggleTextAreaFocused}
                            placeholder="Add your message"
                            class="message-response"
                            classLabel="label-response"
                            onChange={e => {
                                const templatedVersion = e.target.value.replace(
                                    `${this.props.formattedReps}`,
                                    '@localRepresentative'
                                );
                                this.props.onEmailMessageChange();
                                this.props.cacheFormData(
                                    { message: templatedVersion },
                                    this.props.actionIdentifier
                                );
                            }}
                        />
                    </FullRow>
                </Row>
                <ButtonGroup>
                    <TwoGroup>
                        <Button
                            style={{
                                visibility: this.state.textAreaFocused
                                    ? 'hidden'
                                    : 'visible'
                            }}
                            label={copyFor(
                                'buttons',
                                'back',
                                'email',
                                capitalization.eachWord
                            )}
                            onClick={this.props.onBackFromRepAction}
                            className="middleButton"
                        />
                        <Button
                            primary={true}
                            label={
                                this.state.textAreaFocused
                                    ? copyFor(
                                          'buttons',
                                          'done',
                                          'email',
                                          capitalization.eachWord
                                      )
                                    : copyFor(
                                          'buttons',
                                          'continue',
                                          'email',
                                          capitalization.eachWord
                                      )
                            }
                            onClick={e => {
                                e.preventDefault();
                                if (!this.state.textAreaFocused) {
                                    this.props.handleSubmit();
                                }
                            }}
                            type="submit"
                            className="submitButton"
                            disabled={this.props.invalid && !this.state.textAreaFocused}
                            isSubmitting={this.props.isSubmitting}
                        />
                    </TwoGroup>
                </ButtonGroup>
            </DetailsFormContainer>
        );
    }
}

DetailsFormMultiRepStep1.propTypes = {
    actionIdentifier: PropTypes.string.isRequired,
    cacheFormData: PropTypes.func.isRequired,
    formattedReps: PropTypes.string,
    handleSubmit: PropTypes.func.isRequired,
    hiddenRepresentatives: PropTypes.array.isRequired,
    initialValues: PropTypes.object.isRequired,
    invalid: PropTypes.bool.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
    onAddClick: PropTypes.func.isRequired,
    onBackFromRepAction: PropTypes.func,
    onDeleteClick: PropTypes.func.isRequired,
    onEmailMessageChange: PropTypes.func.isRequired,
    onShowRepresentatives: PropTypes.func.isRequired,
    representatives: PropTypes.array.isRequired,
    representativesVisibility: PropTypes.bool,
    requiredFormElements: PropTypes.array.isRequired,
    senatorsNotAvailable: PropTypes.bool
};

export default compose(
    connect(
        state => {
            const formElements = requiredFormElements(state);
            const reps = state.localRep.localRepData
                ? relevantRepresentatives(
                      state.widget.activeAction.representativeSearch,
                      state.localRep.localRepData.representative
                  )
                : [];
            const formattedReps = joinEnglish(
                reps
                    .filter(
                        rep =>
                            rep.canBeEmailed &&
                            state.localRep.hiddenRepresentatives.indexOf(rep.fullName) ===
                                -1
                    )
                    .map(rep => rep.fullName || rep.twitterMention)
            );
            const actionIdentifier = state.widget.activeAction.identifier;

            const cachedMessage = findCachedValueByActionIdentifier(
                state.cachedFormData.message,
                actionIdentifier
            );

            const cachedTopic = findCachedValueByActionIdentifier(
                state.cachedFormData.topic,
                actionIdentifier
            );

            const message =
                state.cachedFormData.message.length > 0 && !!cachedMessage
                    ? cachedMessage
                          .replace(/@localRepresentative/g, formattedReps)
                          .replace(/@userFullName/g, namePlaceholder())
                    : state.widget.activeAction.textRaw
                          .replace(/@localRepresentative/g, formattedReps)
                          .replace(/@userFullName/g, namePlaceholder());

            const topic =
                state.cachedFormData.topic.length > 0 && !!cachedTopic
                    ? cachedTopic
                    : formElements
                          .filter(a => a.name === 'Topic')
                          .map(a =>
                              getActiveTopic(
                                  a.options,
                                  state.widget.activeAction.issue,
                                  state.widget.activeAction.subIssue
                              )
                          )[0];

            return {
                actionIdentifier,
                formattedReps,
                requiredFormElements: formElements,
                initialValues: {
                    getUpdates: !(state.widget.endUserLocation || {}).isEU,
                    message,
                    topic
                },
                representatives: reps
                    .filter(
                        rep =>
                            rep.canBeEmailed &&
                            state.localRep.hiddenRepresentatives.indexOf(rep.fullName) ===
                                -1
                    )
                    .map((a, index) => ({
                        shortName: a.shortName,
                        fullName: a.fullName,
                        photoUrl: a.photoUrl || DefaultRepImageURL,
                        index: index
                    })),
                hiddenRepresentatives: reps
                    .filter(
                        rep =>
                            rep.canBeEmailed &&
                            state.localRep.hiddenRepresentatives.indexOf(rep.fullName) !==
                                -1
                    )
                    .map((a, index) => ({
                        fullName: a.fullName,
                        photoUrl: a.photoUrl || DefaultRepImageURL,
                        index: index
                    })),
                representativesVisibility: state.localRep.representativesVisibility,
                senatorsNotAvailable:
                    state.localRep.localRepData.representative !== undefined
                        ? state.localRep.localRepData.representative.length < 2
                        : false
            };
        },
        {
            cacheFormData
        }
    ),
    reduxForm({
        enableReinitialize: true,
        destroyOnUnmount: false,
        form: 'emailDetailsFormMultiRepStep1',
        validate: validateStep1
    })
)(DetailsFormMultiRepStep1);
